import RecoverStep from "../recover_step";
import {attachRowHandler, showVmsList} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";

const TEMPLATE = 'virtualization-browse';

export default class BrowseLocalVms extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.tmp.previousStep = fr.currentStep;
        data.render = { searchComplete : false };
        data.deviceId = null;
        data.useBrowse = true;

        const renderDevices = function () {
            data.render.searchComplete = true;
            fr.render('browseLocalVms');
        };

        const requestSettings = {
            filter: {jobs: {sva_job_status: "offline", appliance_online: 1}},
            startable: true,
            flowType: data.type
        };

        // if service ID is specified, add it to the filter
        if (data.applianceId) {
            requestSettings.filter.machines = {appliance_id : data.applianceId};
        }

        $.ajax({
            type: "POST",
            url: "/dashboardumc/inventory_data/"+data.clientId+"/VIRTUALIZED",
            data: JSON.stringify(requestSettings),
            success: function(response) {
                if (!response.data.length && response.errors) {
                    data.render = response.errors;
                    fr.goTo('notAvailable');
                } else {
                    data.devices = response.data;
                    renderDevices();
                }
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    postRender(data, el, fr) {
        const $el = $(el);
        if (data.render.searchComplete) {
            attachRowHandler(el);
            alignHeaderOnLimitedHeightTable($el);
        }
        $el.find('tbody tr').on('click', function() {
            const selected_row = $(this);
            data.deviceId = selected_row.find('[name=device]').val();
            if (data.deviceId) {
                data.recovery.device = { display_name: selected_row.find('td:eq(2)').text() };
                data.recovery.device_id = data.deviceId;
                data.recovery.appliance_id = selected_row.find('[name=device]').data('appliance_id');
                data.recovery.device_name = data.recovery.device.display_name;
                fr.goTo('setupLocalVm');
            }
        });
    }

    transitionViewService(data, el, fr) {
        showVmsList(data);
    }

}
